import React, { useContext } from 'react'
import { InitializeContext } from '../../App';
import { Link } from 'react-scroll';
import { BiHomeHeart, BiUser, BiImage, BiBriefcase } from 'react-icons/bi';
import { LiaTelegram } from 'react-icons/lia'
import { MdSpaceDashboard } from 'react-icons/md';
import { IoClose } from 'react-icons/io5';
import { IoSettingsOutline } from 'react-icons/io5';
import ToggleTheme from '../../components/ToggleTheme';

export default function BottomNav() {
  const { theme } = useContext(InitializeContext);

  const scrollToHome = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  };

  const NavMenus = (
    <div className='grid grid-cols-3 gap-8 pt-5 pb-16'>
      <Link
        activeClass={`flex flex-col px-1 py-2 gap-1 justify-center items-center rounded-xl font-semibold glass bg-primary text-white duration-500`}
        className={`flex flex-col px-1 py-2 gap-1 justify-center items-center cursor-pointer shadow-md rounded-xl font-semibold hover:bg-primary hover:text-white duration-500 ${theme ? 'text-white' : 'text-black'}`}
        to="home"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
      >
        <BiHomeHeart size={25} /> <small className='text-xs'>Home</small>
      </Link>
      <Link
        activeClass={`flex flex-col px-1 py-2 gap-1 justify-center items-center rounded-xl font-semibold glass bg-primary text-white duration-500`}
        className={`flex flex-col px-1 py-2 gap-1 justify-center items-center cursor-pointer shadow-md rounded-xl font-semibold hover:bg-primary hover:text-white duration-500 ${theme ? 'text-white' : 'text-black'}`}
        to="about"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
      >
        <BiUser size={22} /> <small className='text-xs'>About</small>
      </Link>
      <Link
        activeClass={`flex flex-col px-1 py-2 gap-1 justify-center items-center rounded-xl font-semibold glass bg-primary text-white duration-500`}
        className={`flex flex-col px-1 py-2 gap-1 justify-center items-center cursor-pointer shadow-md rounded-xl font-semibold hover:bg-primary hover:text-white duration-500 ${theme ? 'text-white' : 'text-black'}`}
        to="skills"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        onSetActive={() => {
          document.title = `Skills | Toufiq Hasan Kiron`;
        }}
      >
        <IoSettingsOutline size={22} /> <small className='text-xs'>Skills</small>
      </Link>
      <Link
        activeClass={`flex flex-col px-1 py-2 gap-1 justify-center items-center rounded-xl font-semibold glass bg-primary text-white duration-500`}
        className={`flex flex-col px-1 py-2 gap-1 justify-center items-center cursor-pointer shadow-md rounded-xl font-semibold hover:bg-primary hover:text-white duration-500 ${theme ? 'text-white' : 'text-black'}`}
        to="services"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
      >
        <BiBriefcase size={22} /> <small className='text-xs'>Services</small>
      </Link>
      <Link
        activeClass={`flex flex-col px-1 py-2 gap-1 justify-center items-center rounded-xl font-semibold glass bg-primary text-white duration-500`}
        className={`flex flex-col px-1 py-2 gap-1 justify-center items-center cursor-pointer shadow-md rounded-xl font-semibold hover:bg-primary hover:text-white duration-500 ${theme ? 'text-white' : 'text-black'}`}
        to="portfolio"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
      >
        <BiImage size={22} /> <small className='text-xs'>Portfolio</small>
      </Link>
      <Link
        activeClass={`flex flex-col px-1 py-2 gap-1 justify-center items-center rounded-xl font-semibold glass bg-primary text-white duration-500`}
        className={`flex flex-col px-1 py-2 gap-1 justify-center items-center cursor-pointer shadow-md rounded-xl font-semibold hover:bg-primary hover:text-white duration-500 ${theme ? 'text-white' : 'text-black'}`}
        to="contact"
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
      >
        <LiaTelegram size={22} /> <small className='text-xs'>Contact</small>
      </Link>
    </div>
  )

  return (
    <div className={`navbar flex justify-between px-5 ${theme ? 'bg-[#212428]' : 'bg-[#ECF0F3]'} max-h-20 shadow-[0px_-2.05128px_20.2564px_rgba(0,0,0,.15)] px-3 md:hidden fixed bottom-0 left-0 right-0 z-50`}>
      <h1 className={`font-bold ${theme ? 'text-white' : ''}`} onClick={scrollToHome}>Toufiq Hasan Kiron</h1>
      <div className='flex items-center'>
        <ToggleTheme />
        <label htmlFor="navMenu">
          <MdSpaceDashboard className={`${theme ? 'text-white' : ''}`} size={25} />
        </label>
        <input type="checkbox" id="navMenu" className="modal-toggle" />
        <div className="modal modal-bottom lg:modal-middle">
          <div className={`modal-box ${theme ? 'bg-[#212428]' : 'bg-[#ECF0F3]'} z-50`}>
            <p className='absolute left-7 bottom-5'>
              <small className={`font-bold text-xs ${theme ? 'text-white' : 'text-black'}`} title='Toufiq Hasan Kiron'>Fav Quote - <span className={`${theme ? 'text-warning' : 'text-primary'}`}>Be Strong, Be Anonymous!</span></small>
            </p>
            <label htmlFor="navMenu" className="btn btn-ghost btn-sm btn-circle absolute right-3 bottom-3">
              <IoClose size={25} className={`${theme ? 'text-white' : 'text-black'}`} />
            </label>
            {NavMenus}
          </div>
        </div>
      </div>
    </div>
  )
}
